import React from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useAamState, useAamGuestInitialization } from '../state/AamStore'
import AAMContent from './AAMContent'
import { setSessionStorageItem } from '../../../shared/helpers/sessionStorage'

export default function AAMGuestMain({ nonstandardUser }) {
  const initData = { page_detail: 'All About Me - Guest' }
  usePageView(initData)
  const appState = useAamState()
  setSessionStorageItem({ redirectToGuestPage: false })
  useAamGuestInitialization(nonstandardUser, appState) // Using effective user vs user to support helper mode)
  return <AAMContent tileData={appState.tileData} year={appState.year} />
}
